//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            // 图片路径
            imgUrl:'',
            // 完成后显示
            is_complete:false,
            is_prompt:false,
            is_enter:false,
            is_time:false,
            is_residue:false,
            icon:'',
            loading:false,
            project_info:'',
            // 数据 技师
            show1:false,
            ename_list:[],
            title_ename:'请选择技师',
            active_eid:'',
            // 数据 时间
            show2:false,
            time_list:[],
            title_time:'请选择时间',
            active_time:'',
            date_list:[],
            active_date:"",
            // 备注
            remake:"",
            // 预约当天时间 
            appoint_day:'',
            // 预约开始时间
            appoint_time:'',
            // 预约结束时间
            appoint_end_time:'',
            // 预约时间展示  如09:00~10:00
            appoint_times:'',
            // 预约时间数组  如['0900','0915','0930','0945']
            time_id:[],
        }
    },
    activated(){
        // 获取图片路径
        this.imgUrl =  sessionStorage.getItem('ossPath')
        // 清除数据
        this.is_complete = false
        this.is_prompt = false
        this.loading=false
        this.title_ename='请选择技师'
        this.active_eid= ''
        this.title_time='请选择时间'
        this.active_time = ''
        this.active_date = ''
        this.active_item = ''
        this.remake = ''
        this.appoint_time = ''
        this.appoint_end_time = ''
        this.appoint_times = ''
        this.time_id = []
        // 项目信息
        let info = this.$route.params.info
        info.employee.forEach(item => {
            item.portrait = this.imgUrl + item.idphoto
        })
        console.log(info);
        this.project_info = info
        this.ename_list = info.employee
        //获取日期 本日到一个月后的时间
        this.getDateList()
    },
    methods:{
        onShow1(){
            this.show1 =true
        },
        enter_popup1(item){
            this.title_ename = item.name
            this.active_eid = item.id
            // 清除数据
            this.title_time='请选择时间'
            this.active_time = this.time_list[0].timestamp
            this.active_date = ''
            this.active_item = ''
            this.remake = ''
            this.appoint_time = ''
            this.appoint_end_time = ''
            this.appoint_times = ''
            this.time_id = []
            this.show1 = false
        },
        onShow2(){
            if(this.active_eid){
                this.getEmployeeTime()
                this.show2 =true
            }else{
                this.is_prompt = true
            }
        },
        close_popup2(){
            // let arr = this.appoint_times.split('~')
            // this.active_date = arr[0]
            // this.active_time = this.appoint_day
            this.show2 = false
        },
        enter_popup2(){
            // 必须选择日期
            if(!this.active_date){
               this.is_time = true
               return
            }
            // 判断是否时间充足
            let count  = this.project_info.work_hours / 15
            let ind =  this.date_list.indexOf(this.active_item)
            // console.log(ind);  初始下标
            let newList = this.date_list.slice(ind , ind + count)
            // console.log(newList);  切割后数组
            let is_newList = false
            newList.forEach(item => {
                if(item.status == 0){
                    is_newList = true
                }
            })
            if(is_newList){
                this.is_residue = true
                return
            }
            // 当天零点时间
            this.appoint_day = this.active_time
            let hour = Number(this.active_item.hour)
            let minutes = Number(this.active_item.minutes)
            // 今日开始时间秒  00:00开始到当前时间
            let start_seconds = hour * 60 * 60 + minutes * 60
            // 今日结束时间秒   00:00开始到结束时间
            let end_seconds = start_seconds + this.project_info.work_hours * 60
            // console.log(start_seconds);
            // console.log(end_seconds);
            this.appoint_time = this.active_time + start_seconds
            this.appoint_end_time = this.active_time + end_seconds 
            // 时间展示
            let start = new Date(this.appoint_time * 1000)
            let end = new Date(this.appoint_end_time * 1000)
            let statr_hour = (start.getHours() < 10 ? '0' + start.getHours() : start.getHours())
            let statr_minu = (start.getMinutes() < 10 ? '0' + start.getMinutes() : start.getMinutes()) 
            let end_hour = (end.getHours() < 10 ? '0' + end.getHours() : end.getHours())
            let end_minu = (end.getMinutes() < 10 ? '0' + end.getMinutes() : end.getMinutes()) 
            let start_str = statr_hour + ':' + statr_minu
            let end_str = end_hour + ':' + end_minu
            this.appoint_times = start_str + '~' + end_str
            // console.log(this.appoint_times);
            //  占用的时间段的数组
            let is = false
            let arr = []
            this.date_list.forEach(item => {
                if(item.date == start_str){
                    is = true
                }
                if(item.date == end_str){
                    is = false
                }
                if(is){
                    let str = item.hour + '' + item.minutes
                    arr.push(str)
                }
            })
            this.time_id = arr
            console.log(this.time_id);
            this.title_time = this.appoint_times
            this.show2 = false
        },
        // 获取日期
        async getDateList(){
            let res = await this.$HTTP.HttpPost('/member/Appointment/getMonthDay')
            this.time_list = res.data.data
            // 初始选中今天
            this.active_time = this.time_list[0].timestamp
        },
        // 切换日期
        onChageTime(item){
            // console.log(item);
            if(item.timestamp == this.active_time){
                return
            }
            this.active_time= item.timestamp
            this.active_date = ''
            this.getEmployeeTime()
        },
        // 获取员工可预约时间
        async getEmployeeTime(){
            let data = {
                eid:this.active_eid,
                time:this.active_time
            }
            let res = await this.$HTTP.HttpPost('/member/Appointment/getEmployeeTime',data)
            let arr = []
            let is = false
            res.data.data.forEach(item => {
                // if(item.status == 1){
                //     item.date = item.hour+':'+item.minutes
                //     arr.push(item)
                // }
                if(item.status == 1){
                    is = true
                }
                if(is){
                    item.date = item.hour+':'+item.minutes
                    arr.push(item)
                }
            });
            this.date_list = arr
            // console.log(this.date_list);
        },
        onClickTag(item){
            console.log(item);
            this.active_date = item.date
            this.active_item = item
        },
        // 预约
        async onEnter(){
            // this.loading = true
            // setTimeout(() => {
            //     this.loading = false
            // }, 2000);
            // setTimeout(() => {
            //     this.is_complete = true
            // }, 3000);
            let {appoint_day,appoint_end_time,appoint_time,appoint_times,time_id,active_eid} = this
            if(appoint_day && appoint_end_time && appoint_time && appoint_times && time_id && active_eid){
                let sid = sessionStorage.getItem('sid') - 0
                let data = {
                    appoint_day:this.appoint_day,
                    appoint_time:this.appoint_time,
                    appoint_end_time:this.appoint_end_time,
                    appoint_times:this.appoint_times,
                    item_id:this.project_info.item_id,
                    item_name:this.project_info.service_item_name,
                    remark:this.remake,
                    time_id:this.time_id,
                    eid:this.active_eid,
                    sid:sid
                }
                console.log(data);
                this.loading = true
                let res = await this.$HTTP.HttpPost('/member/Appointment/appointment',data)
                if(res.data.code == 200){
                    setTimeout(() => {
                        this.loading = false
                    },800)
                    setTimeout(() => {
                        this.is_complete = true
                    },1000);
                }
            }else{
                this.is_enter = true
                console.log('数据缺失');
                return
            }
        },
        // 完成退出按钮
        onReturn(){
            this.$router.go(-1)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/projectdetails.vue